import Cell from './elements/Cell'
import { ColumnConfig, type ColumnField } from './types'
import { DefaultCellRenderer } from '../utils'
import type { ColumnWidth } from '../utils/calculateColumnWidths'
import type { ReactNode } from 'react'
type CommonColumnWidth = Pick<ColumnWidth, 'width' | 'minWidth' | 'maxWidth'>

function ValueCell<T extends Record<string, unknown>, K extends ColumnField<T>>({
  render,
  value,
  children,
  className,
  ...widths
}: {
  render: ColumnConfig<T, K>['render']
  value: T[K]
  children?: ReactNode
  className?: string
} & CommonColumnWidth) {
  const Content = render ?? DefaultCellRenderer<T, K>
  return (
    <Cell {...widths} className={className}>
      {children}
      <Content value={value} />
    </Cell>
  )
}

export default ValueCell
